import React from 'react'
import { Button, ChevronDownIcon, ChevronUpIcon } from '@paypalcorp/pp-react'
import styles from './AiSearch.module.css'

const SeeMore = ({
  answerId,
  searchID,
  seeMore,
  setSeeMore,
  isStreamingComplete,
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti

  const onSeeMoreClick = () => {
    setSeeMore(!seeMore)
    const seeMoreToggle = seeMore ? 'show' : 'hide'
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          tag: `see more-${seeMoreToggle}`,
          link: `see more-${seeMoreToggle}`,
          value: seeMoreToggle,
          component: 'devdiscoverynodeweb',
          answerId,
          name: 'gen_ai_summary',
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.recordClick(options)
      }
    }
  }

  const buttonText = seeMore ? (
    <span className={styles.seeMoreButton}>
      <span className={styles.pr05}>See more</span>{' '}
      <ChevronDownIcon size="xs" />
    </span>
  ) : (
    <span className={styles.seeMoreButton}>
      <span className={styles.pr05}>Hide</span> <ChevronUpIcon size="xs" />
    </span>
  )
  return (
    <Button tertiary onClick={onSeeMoreClick}>
      {buttonText}
    </Button>
  )
}

export default SeeMore
